
import { Component, Vue } from 'vue-property-decorator';
import PortalHeader from '@/components/Layout/PortalHeader.vue';
import ActiveLoanSelector from '@/components/MultiLoan/ActiveLoanSelector.vue';
import { AvailableLoan } from '@/interfaces/loan';

@Component({ components: { ActiveLoanSelector, PortalHeader } })
export default class Portal extends Vue {
  loading = true;

  async created() {
    try {
      const userInfo = await this.$store.dispatch('User/fetchUserInfo');

      if (!this.hasOnlyRepayLoans && !this.hasPaymentMethods && this.$route.name !== 'payment-setup') {
        this.$router.push({ name: 'payment-setup' });
        return;
      }

      if (!this.$store.getters['User/activeLoanNumber']) {
        const loans = userInfo.loans;
        if (loans.length > 1) {
          this.$router.push({ name: 'select-loan' });
          return;
        }
      }

      await this.$store.dispatch('PaymentOptions/getPaymentOptions');
    } catch {
      this.$router.push({ name: 'error' });
    } finally {
      this.loading = false;
    }
  }

  get hasMultipleLoans(): boolean {
    return this.$store.getters['User/availableLoans'].length > 1;
  }

  get hasPaymentMethods(): boolean {
    return this.$store.getters['User/hasPaymentMethods'];
  }

  get hasOnlyRepayLoans(): boolean {
    return this.$store.getters['User/availableLoans'].every((l: AvailableLoan) => !l.is_visible);
  }
}
